import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { DateInput } from '@blueprintjs/datetime';
import { Icon } from '@blueprintjs/core';
import moment from 'moment';

const base = 'secondary-header';

@inject('PickModeStore')
@observer
class PickModeHeader extends Component {
    state = {
        currentTime: null,
    };

    componentDidMount = () => {
        this.currentTime();
    };

    handleSetDate = (forceLatest, momentDate) => {
        const {
            PickModeStore: { setDate },
        } = this.props;
        const date = moment(momentDate).format('DD-MM-YYYY');
        setDate(date);
    };

    currentTime = () => {
        const currentTime = moment().format('LTS');
        this.setState({ currentTime });
        setTimeout(this.currentTime, 1000);
    };

    componentWillUnmount() {
        clearTimeout(this.currentTime);
    }

    render() {
        const { currentTime } = this.state;
        const {
            goFullscreen,
            PickModeStore: { date },
        } = this.props;

        return (
            <div className={`${base}__wrapper bg--white`}>
                <div className={`${base} display--flex  pll prl ptm pbm`}>
                    <div
                        className={`${base}__left display--flex justify--space-between flex-align-items-center`}
                    >
                        <DateInput
                            formatDate={(date) =>
                                moment(date).date() === moment().date()
                                    ? moment(date).format(
                                          '[Today •] DD/MM/YYYY'
                                      )
                                    : moment(date).format('DD/MM/YYYY')
                            }
                            onChange={(date) => this.handleSetDate(true, date)}
                            parseDate={(str) =>
                                moment(str, 'DD/MM/YYYY').toDate()
                            }
                            placeholder="Pick a date"
                            value={moment(date, 'DD/MM/YYYY').toDate()}
                            inputProps={{ leftIcon: 'calendar' }}
                            showActionsBar
                            className="date-input"
                        />
                        <p className="fs--medium-medium-large m0 mlm">
                            {currentTime}
                        </p>
                    </div>
                    <div
                        className={`${base}__right display--flex justify--space-between flex-align-items-center`}
                    >
                        <button
                            className={`btn btn-borderless mls`}
                            onClick={() => goFullscreen()}
                        >
                            <Icon icon="fullscreen" iconSize={24} />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default PickModeHeader;
